const distance = (first, second) => Math.hypot(first.x - second.x, first.y - second.y);
const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

/**
 * Two fingers in the pane or on the price axis: the distance between them zooms, the bar
 * between them stays under them, so moving both fingers also pans.
 *
 * @param {object} view - see createInteraction
 * @param {{ x: number, y: number }} first - CSS px
 * @param {{ x: number, y: number }} second
 * @returns {{ move: (first: object, second: object) => void, end: () => void }}
 */
export const createPinchZoom = (view, first, second) => {
  const { timeScale } = view;
  // Fingers on the price axis zoom around the right edge of the pane, not past it
  const middleX = (one, other) => clamp((one.x + other.x) / 2, 0, timeScale.width);
  const startDistance = Math.max(1, distance(first, second));
  const startSpacing = timeScale.barSpacing;
  const anchorIndex = timeScale.xToIndex(middleX(first, second));

  return {
    move: (nextFirst, nextSecond) => {
      const scale = distance(nextFirst, nextSecond) / startDistance;

      timeScale.placeIndexAt(anchorIndex, middleX(nextFirst, nextSecond), startSpacing * scale);
      view.invalidate();
    },
    end: () => {},
  };
};
